import React, { Component } from "react";

import { StyleSheet, Content, View, Navigator, Text } from "react-1app";

import Menu from "./Menu.js";
import Novidades from "./Novidades.js";

export default class Init extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    Navigator.cloneState(this);
  }

  componentDidMount() {
    this.unsubscribe = this.props.screenProps.store.subscribe(() => {
      this.setState(this.props.screenProps.store.getState());
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    return (
      <Content style={styles.content}>
        <Menu
          style={styles.fragment}
          screenProps={this.props.screenProps}
          navigation={this.props.navigation}
          activity={this}
          oldState={this.state}
        />
        <View style={styles.view11}>
          <Text
            style={styles.text11}
            text={"Kafer Churrasqueiras"}
            elevation={"3"}
          />
          <Text
            style={styles.text211}
            text={
              "Focada na inovação, qualidade e tecnologia, desde 2003 a Kafer fabrica churrasqueiras sob-medida para que você usufrua ao máximo seu tempo livre. Utilizando somente materiais de alta qualidade, os produtos Kafer são feitos para durar.  Líder de mercado, fornece os melhores produtos para você aprimorar o seu churrasco. Produzida exclusivamente em materiais nobres com precisão e extremo cuidado nos acabamentos, a Kafer é a opção ideal para quem quer excelência, sofisticação e tecnologia.  A Equipe Kafer conta com profissionais treinados na empresa, mantendo o alto padrão no atendimento, com total suporte da empresa.  Equipes de venda, instalação e assistência técnica de prontidão para auxiliar em todas as etapas do processo, desde a escolha do produto até a instalação. Tudo isso para que você desfrute do seu tempo livre deixando o resto por nossa conta."
            }
          />
        </View>
      </Content>
    );
  }
}

var styles = StyleSheet.create({
  content: {
    backgroundColor: "rgba(205,205,205,1)",
    alignSelf: "stretch",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row"
  },
  fragment: {
    alignSelf: "stretch"
  },
  view11: {
    alignSelf: "stretch",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  text11: {
    textAlign: "left",
    color: "rgba(255,146,0,1)",
    alignSelf: "center",
    fontWeight: "normal",
    marginTop: 50,
    fontSize: 50
  },
  text211: {
    textAlign: "justify",
    color: "rgba(69,69,69,1)",
    alignSelf: "center",
    fontWeight: "normal",
    marginTop: 40,
    maxWidth: 400
  }
});



// WEBPACK FOOTER //
// ./src/views/Init.js